import _defineProperty from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React__default from 'react';
import classNames from 'classnames';
import OutlineClose from '../icons/generated/outline/OutlineClose.js';
var CentralizedModal = function CentralizedModal(_ref) {
  var children = _ref.children,
    customClass = _ref.customClass,
    isActive = _ref.isActive,
    handleCloseModal = _ref.handleCloseModal,
    _ref$hasOverlay = _ref.hasOverlay,
    hasOverlay = _ref$hasOverlay === void 0 ? true : _ref$hasOverlay,
    _ref$hasCloseButton = _ref.hasCloseButton,
    hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton;
  var classes = classNames("iq-centralized-modal", _defineProperty({
    "iq-centralized-modal--active": isActive
  }, customClass, customClass));
  return /* @__PURE__ */React__default.createElement("section", {
    className: classes
  }, hasOverlay && /* @__PURE__ */React__default.createElement("div", {
    className: "iq-centralized-modal__overlay"
  }), /* @__PURE__ */React__default.createElement("div", {
    className: "iq-centralized-modal__content"
  }, hasCloseButton && /* @__PURE__ */React__default.createElement("div", {
    className: "iq-centralized-modal__button"
  }, /* @__PURE__ */React__default.createElement("button", {
    onClick: handleCloseModal,
    "aria-label": "Fechar modal"
  }, /* @__PURE__ */React__default.createElement(OutlineClose, null))), children));
};
export { CentralizedModal as default };